import Component from './Component';

export default class Countdown extends Component {
  load() {
    this.initCountdown();

    super.load();
  }


  initCountdown() {
    // console.log('initCountdown');
    let interval = 1000; // 1 second

    // doIntervalActions(); // run once early (useful for debugging styling combine with a long interval)

    // loop to countdown
    setInterval(function () {
      // This will continue looping even if a countdown is at 00, just in case there are multiple countdowns.
      // TODO: We could do a check if all countdowns are 00 then cancel the setInterval.
      doIntervalActions();
    }, interval);



    function doIntervalActions() {
      let countdowns = document.querySelectorAll('.countdown[data-value]');
      // console.log('all countdowns: ', countdowns);

      countdowns.forEach((el) => {
        updateCountdown(el);
      });
    }


    function updateCountdown(countEl) {
      // console.log('countEl: ', countEl);
      // console.log('countEl.firstChild: ', countEl.firstChild);

      // get event date from HTML data attribute
      let eventTime = countEl.getAttribute('data-value');
      let time = getTimeRemaining(eventTime);  // calculate time remaining

      // Delete old countdown elements
      removeAllChildNodes(countEl);

      // Create a document fragment to hold the elements
      const fragment = new DocumentFragment();

      // Define a template for the time units
      const template = (classId, label, value) => {
        const div = document.createElement('div');
        div.className = `countdown__item countdown__${classId} d-flex justify-content-center`;
        div.innerHTML = `
          <span class='countdown__time px-2'>${value}</span>
          <span class='countdown__label px-2'>${label}</span>
        `;
        return div;
      };

      // Append each time unit using the template literal
      fragment.appendChild(template('days', 'Days', time.days));
      fragment.appendChild(template('hours', 'Hours', time.hours));
      fragment.appendChild(template('minutes', 'Minutes', time.minutes));
      fragment.appendChild(template('seconds', 'Seconds', time.seconds));

      // Append the fragment to the DOM in a single update
      countEl.appendChild(fragment);
    }


    function getTimeRemaining(eventTime) {
      // console.log('calc eventTime:', eventTime);
      // console.log('new Date:', new Date());
      let seconds = '00';  // defaults
      let minutes = '00';
      let hours = '00';
      let days = '00';

      const total = Date.parse(eventTime) - Date.parse(new Date());
      // console.log('total: ', total);

      if (total > 0) {
        seconds = Math.floor( (total/1000) % 60 );
        minutes = Math.floor( (total/1000/60) % 60 );
        hours = Math.floor( (total/(1000*60*60)) % 24 );
        days = Math.floor( total/(1000*60*60*24) );
      }

      return {
        total,
        days,
        hours,
        minutes,
        seconds
      };
    }


    function removeAllChildNodes(parent) {
      while (parent.firstChild) {
          parent.removeChild(parent.firstChild);
      }
    }


  }
}
